angular.module('unergie.main')
.controller('loginModalCtrl', ($window, $scope, $uibModalInstance, ApiUser, AuthService, AlertManager, ErrorCatcher, Technical) => {
    $scope.close = $uibModalInstance.dismiss
    $scope.errorMessage = undefined

    $scope.loginInfo = {
        username: '',
    }

    $scope.doLogin = function (e) {
        e.preventDefault()
        if (!$scope.loginInfo.username || !$scope.loginInfo.password) {
            return AlertManager.error(`Veuillez renseigner les champs login et mot de passe`)
        }
        $scope.loginIn = true
        $scope.errorMessage = undefined
        return ApiUser.login($scope.loginInfo).$promise.then((response) => {
            window.location.reload()
            $scope.close()
        }).catch((error) => {
            $scope.errorMessage = error.data.message
        })
        .finally(() => {
            $scope.loginIn = false
        })
    }

    $scope.forgotFields = {
        username: {
            label: 'E-mail',
            required: true,
            type: 'email',
        },
    }

    $scope.forgotPassword = function (isFirstConnection) {
        if (isFirstConnection) {
            $scope.sendingFirstConnectionMail = true
        } else {
            $scope.sendingMail = true
        }
        return ApiUser.resetPassword({ email: $scope.loginInfo.username, isFirstConnection }).$promise.then(() => {
            $scope.okMessage = 'E-mail envoyé, rendez-vous dans votre boîte mail.'
        })
        .catch((error) => {
            $scope.errorMessage = error.data.message
        })
        .finally(() => {
            $scope.sendingMail = false
            $scope.sendingFirstConnectionMail = false
        })
    }

    // check if cert
    $scope.certificateChecked = false
    $scope.certificatePresent = false
    Technical.checkCertificate().$promise.then((result) => {
        if (result) {
            $scope.certificateChecked = true
            $scope.certificatePresent = result.certificate
        } else {
            throw new Error('Missing result object')
        }
    }).catch((err) => {
        console.error(`Unable to check certificate presence: ${err}`)
    })
})
